import React, { useEffect, useState } from "react";
import Button from "../form/Button";
import { useTranslation } from "react-i18next";
import InviteUserPopup from "../popup/InviteUserPopup";

const DashboardButtonGroup = ({ isSuccessorCount, successorCount, id }) => {
  const { t } = useTranslation();
  const role = localStorage.getItem("role");
  const [enabledInviteUserPopup, setEnabledInviteUserPopup] = useState(false);
  const [actionValue, setActionValue] = useState({});

  return (
    <>
      {role && (role === "customer-admin" || role === "customer-subadmin") && (
        <Button
          buttonType={"button"}
          buttonIcon={"fa-light fa-user-plus"}
          buttonIconPosition={"left"}
          buttonLabel={t("invite_user")}
          buttonHasLink={false}
          functions={() => {
            setEnabledInviteUserPopup(true);
          }}
          buttonClasses={
            "!rounded-full !bg-transparent !text-black !border !border-black"
          }
        />
      )}
      {isSuccessorCount && successorCount === 0 && (
        <Button
          buttonType={"button"}
          buttonIcon={"fa-light fa-plus"}
          buttonIconPosition={"left"}
          buttonLabel={t("create_succession_plan")}
          buttonHasLink={true}
          buttonLink={"/add-successor"}
          buttonClasses={
            "!rounded-full !bg-transparent !text-black !border !border-black"
          }
        />
      )}
      {isSuccessorCount && successorCount > 0 && (
        <Button
          buttonType={"button"}
          buttonIcon={"fa-light fa-circle-user"}
          buttonIconPosition={"left"}
          buttonLabel={t("your_succession_plan")}
          buttonHasLink={true}
          buttonLink={"/profiles"}
          buttonClasses={
            "!rounded-full !bg-transparent !text-black !border !border-black"
          }
        />
      )}
      {enabledInviteUserPopup && (
        <InviteUserPopup
          isOpen={enabledInviteUserPopup}
          setIsOpen={(val) => setEnabledInviteUserPopup(val)}
          data={""}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
          id={id}
        />
      )}
    </>
  );
};

export default DashboardButtonGroup;
